import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { IoLogoYoutube, IoCall, IoCart, IoPersonCircleOutline } from "react-icons/io5";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import logo from '../Assets/hariom/logohariom.png';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../slice/userSlice';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const userDropdownRef = useRef(null);
    const mobileUserDropdownRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const cartData = useSelector((store) => store.cart);
    const userData = useSelector((store) => store.user);
    const cartCount = cartData.reduce((total, item) => total + Number(item?.qty || 1), 0);
    const authRedirectState = {
        from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
        },
    };

    useEffect(() => {
        document.body.classList.remove("no-scroll");
        document.body.classList.remove("scrolled");
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                document.body.classList.remove("no-scroll");
                setIsMobileMenuOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            const insideDesktop = userDropdownRef.current && userDropdownRef.current.contains(event.target);
            const insideMobile = mobileUserDropdownRef.current && mobileUserDropdownRef.current.contains(event.target);
            if (!insideDesktop && !insideMobile) {
                setIsUserDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(prev => {
            const next = !prev;
            document.body.classList.toggle('no-scroll', next);
            return next;
        });
    };

    const toggleUserDropdown = () => {
        setIsUserDropdownOpen(!isUserDropdownOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        setIsUserDropdownOpen(false);
        document.body.classList.remove('no-scroll');
    };

    return (
<header id="header" className="header sticky-top">

  {/* ===== TOP BAR ===== */}
  <div className="topbar d-flex align-items-center">
    <div className="container d-flex justify-content-md-between justify-content-center">
      <div className="contact-info d-flex align-items-center text-white">
        <Link to="mailto:homesexologyclinic@gmail.com" className="text-decoration-none text-white ml-lg-1">
          homesexologyclinic@gmail.com
        </Link>
        <IoCall className="ml-3" />
        <a href="tel:+918989447040" className="text-white ml-1">8989447040</a>
        <a href="tel:+919039303090" className="text-white ml-3 topbar-secondary-phone">9039303090</a>
      </div>

      <div className="social-links d-none d-md-flex align-items-center mr-lg-2">
        <a href="https://x.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
        <a href="https://www.facebook.com" target="_blank" rel="noreferrer"><FaFacebook /></a>
        <a href="https://www.instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
        <a href="https://youtube.com" target="_blank" rel="noreferrer"><IoLogoYoutube /></a>
        <a href="https://wa.me/919039303090" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
      </div>
    </div>
  </div>

  {/* ===== MAIN NAV ===== */}
  <div className="branding">
    <div className="container position-relative">

      <Link to="/" className="logo" onClick={closeMobileMenu}>
        <img src={logo} alt="drnksondhiya" />
      </Link>

      <nav id="navmenu" className={`navmenu ${isMobileMenuOpen ? "open" : ""}`}>

    
        {isMobileMenuOpen && (
          <div className="mobile-menu-close d-xl-none">
            <IoMdClose onClick={closeMobileMenu} />
          </div>
        )}

        <ul>

          <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>

          <li><Link to="/services" onClick={closeMobileMenu}>Services</Link></li>

          <li><Link to="/medicines" onClick={closeMobileMenu}>Plans</Link></li>
          <li><Link to="/aboutus" onClick={closeMobileMenu}>About</Link></li>

          {/* <li className={`dropdown ${isTeamsDropdownOpen ? "active" : ""}`}>
            <span onClick={toggleTeamsDropdown}>Our Team</span>
            <ul>
              <li><Link to="/ourdoctors" onClick={closeMobileMenu}>Our Doctors</Link></li>
              <li><Link to="/ourteam" onClick={closeMobileMenu}>Leadership & Management</Link></li>
            </ul>
          </li> */}

          <li><Link to="/photogallery" onClick={closeMobileMenu}>Our Gallery</Link></li>

          
          <li className="d-xl-none">
            <Link to="/makeappointment" className="cta-btn" onClick={closeMobileMenu}>
              Make an Appointment
            </Link>
          </li>

          <li className="d-xl-none mobile-header-actions">
            {userData?.isLogin ? (
              <div
                ref={mobileUserDropdownRef}
                className={`dropdown mobile-user-dropdown ${isUserDropdownOpen ? "active" : ""}`}
              >
                <button
                  type="button"
                  className="header-action-icon"
                  // style={{ color: 'rgb(94, 39, 80)' }}
                  onClick={toggleUserDropdown}
                  aria-label="User menu"
                  aria-expanded={isUserDropdownOpen}
                >
                  <IoPersonCircleOutline />
                </button>
                <ul>
                  <li><Link to="/myorder" onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); }}>My Order</Link></li>
                  <li><Link to="/myprofile" onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); }}>My Profile</Link></li>
                  <li>
                    <button
                      className="dropdown-item bg-danger text-white"
                      onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); dispatch(logout()); }}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <Link to="/login" state={authRedirectState} className="header-action-icon" onClick={closeMobileMenu} aria-label="Login">
                <IoPersonCircleOutline />
              </Link>
            )}

            <Link to="/cart" className="header-action-icon header-cart-icon" onClick={closeMobileMenu} aria-label="Cart">
              <IoCart />
              <span>{cartCount}</span>
            </Link>
          </li>

          <li><Link to="/contact" onClick={closeMobileMenu}>Contact Us</Link></li>

        </ul>
      </nav>

      <div className="header-right-cluster d-none d-xl-flex">
        <div className="header-right-actions">
          {userData?.isLogin ? (
            <div ref={userDropdownRef} className={`dropdown header-user-dropdown ${isUserDropdownOpen ? "active" : ""}`}>
              <button
                type="button"
                className="header-action-icon"
                style={{ color: 'rgb(94, 39, 80)' }}
                onClick={toggleUserDropdown}
                aria-label="User menu"
                aria-expanded={isUserDropdownOpen}
              >
                <IoPersonCircleOutline />
              </button>
              <ul>
                <li><Link to="/myorder" onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); }}>My Order</Link></li>
                <li><Link to="/myprofile" onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); }}>My Profile</Link></li>
                <li>
                  <button
                    className="dropdown-item bg-danger text-white"
                    onClick={() => { closeMobileMenu(); setIsUserDropdownOpen(false); dispatch(logout()); }}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <Link to="/login" state={authRedirectState} className="header-action-icon" onClick={closeMobileMenu}>
              <IoPersonCircleOutline />
            </Link>
          )}

          <Link to="/cart" className="header-action-icon header-cart-icon" onClick={closeMobileMenu}>
            <IoCart />
            <span>{cartCount}</span>
          </Link>
        </div>

        <Link className="cta-btn" to="/makeappointment">
          Make an Appointment
        </Link>
      </div>

      <IoMdMenu
        className="mobile-nav-toggle d-xl-none"
        onClick={toggleMobileMenu}
      />

    </div>
  </div>
</header>
    );
};

export default Header;
